import api from './api';

export type MissingTranslationSource = 'food' | 'workout' | 'workout_v2' | 'medication';

export interface MissingTranslationItem {
  type: MissingTranslationSource;
  id: number;
  nameRu: string | null;
  nameEn: string | null;
  createdAt: string;
}

export const translationAuditService = {
  getMissingUkTranslations: async (limitPerType = 500) => {
    const res = await api.get('/developer/missing-translations', { params: { limitPerType } });
    return {
      items: res.data.data as MissingTranslationItem[],
      total: res.data.meta.total as number,
    };
  },
};
